<!-- <p>You are not signed in</p> -->
<div class="centers">
    <span class="material-icons icon-clr">error</span>
    <h1 mat-dialog-title>!! PAGE NOT FOUND !!</h1>
    <div mat-dialog-content>
        <p style="margin: 0px 35%;">Please Try Again</p>
    </div>
    <div mat-dialog-actions>
        <button mat-stroked-button color="primary" mat-dialog-close cdkFocusInitial style="margin: 25px 38%;" (click)="refreshClicked()">Refresh</button>
    </div> 
</div>